import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import moment from 'moment';
import map from 'lodash/map';
import split from 'lodash/split';
import { AppContext } from 'context';
import { getDays, getMonths, getYears } from 'helpers/datetime';
import Select from 'components/Form/Select';
import App from 'modules/App';
import styles from './DateOfBirthFormPartial.pcss';
const allowedFormats = [
    'DD-MM-YYYY',
    'YYYY-MM-DD',
    'MM-DD-YYYY'
];
const defaultFormat = 'DD-MM-YYYY';
const useFields = ({ birthMonth, birthYear, momentDate, isDisabled })=>{
    const { cookies } = useContext(AppContext);
    const dobFormatCookie = cookies && cookies.get(App.constants.DOB_FORMAT_COOKIE);
    const order = allowedFormats.includes(dobFormatCookie) ? dobFormatCookie : defaultFormat;
    const renderOrder = split(order, '-');
    const fieldsMap = {
        DD: /*#__PURE__*/ _jsx(Select, {
            id: "day",
            optionsFrom: map(getDays(birthMonth, birthYear), (day)=>({
                    day,
                    label: momentDate.date(day).format('D')
                })),
            valueKey: "day",
            labelKey: "label",
            noValueMessage: App.messages.placeholders.day,
            isDisabled: isDisabled,
            containerClassName: styles.day
        }, "day"),
        MM: /*#__PURE__*/ _jsx(Select, {
            id: "month",
            optionsFrom: map(getMonths(), (month, idx)=>({
                    value: idx + 1,
                    label: month
                })),
            valueKey: "value",
            labelKey: "label",
            noValueMessage: App.messages.placeholders.month,
            isDisabled: isDisabled,
            containerClassName: styles.month
        }, "month"),
        YYYY: /*#__PURE__*/ _jsx(Select, {
            id: "year",
            optionsFrom: map(getYears(), (year)=>({
                    year,
                    label: moment().year(year).format('YYYY')
                })),
            valueKey: "year",
            labelKey: "label",
            noValueMessage: App.messages.placeholders.year,
            isDisabled: isDisabled,
            containerClassName: styles.year
        }, "year")
    };
    return renderOrder.map((field)=>fieldsMap[field]);
};
export default useFields;
